import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Combien coûte un site web dans le Tarn ?",
    a: "Chez WebUP, notre Pack Site Web Professionnel commence à 1 000 € pour un site vitrine complet, responsive, optimisé SEO local et livré clés en main. Les projets plus avancés (refonte, automatisations, IA) sont chiffrés sur devis après un brief gratuit.",
  },
  {
    q: "Combien de temps faut-il pour créer un site web ?",
    a: "Pour un site vitrine standard, comptez 2 à 4 semaines entre le brief initial et la mise en ligne. Vous recevez une première maquette sous 48 h. Les projets plus larges (e-commerce, intégrations IA) peuvent demander 6 à 10 semaines.",
  },
  {
    q: "Pourquoi avoir un site internet quand on est artisan dans le Tarn ?",
    a: "Plus de 80 % des recherches locales démarrent sur Google. Pour un artisan ou un commerce de proximité — à Albi, Gaillac, Castres ou Carmaux — un site bien référencé est aujourd'hui le moyen le plus rentable de générer des demandes de devis qualifiées.",
  },
  {
    q: "Qu'est-ce que le référencement Google et pourquoi c'est important ?",
    a: "Le référencement, c'est l'ensemble des techniques qui font apparaître votre site en premier sur Google. Sans référencement, votre site est invisible pour les clients qui cherchent vos services — quel que soit son design.",
  },
  {
    q: "Comment être trouvé sur Google dans le Tarn ?",
    a: "Plusieurs éléments comptent : une fiche Google (Maps) bien remplie, un site rapide, du contenu adapté aux villes du Tarn (Marssac, Albi, Gaillac, Castres…), des avis clients et des pages dédiées à chaque service. Nous prenons tout cela en charge dans chaque création de site.",
  },
  {
    q: "Qu'est-ce qu'une fiche Google (Maps) et faut-il en avoir une ?",
    a: "C'est la petite fiche gratuite qui affiche votre entreprise sur Google Maps (photo, adresse, horaires, avis). C'est l'un des outils les plus efficaces pour les commerces et artisans locaux. Nous la créons, l'optimisons et la tenons à jour pour vous.",
  },
  {
    q: "Mon site fonctionnera-t-il sur téléphone ?",
    a: "Oui, systématiquement. Chaque site s'affiche parfaitement sur téléphone, tablette et ordinateur. Plus de 70 % de vos visiteurs arrivent depuis leur mobile : c'est une priorité absolue.",
  },
  {
    q: "Proposez-vous une maintenance après la mise en ligne ?",
    a: "Oui. Notre contrat de maintenance est à 30 €/mois et inclut les mises à jour techniques, les sauvegardes hebdomadaires, le support et les petites modifications de contenu (numéro, horaires, photos, nouveaux services, textes, actualités…). Il vous évite toute mauvaise surprise et garde votre site rapide et sécurisé.",
  },
  {
    q: "Quelles modifications sont incluses dans la maintenance ?",
    a: "Le contrat de maintenance à 30 €/mois inclut : changement de numéro de téléphone, modification des horaires, ajout de photos, modification d'un texte, ajout d'un nouveau service, mise à jour des coordonnées, correction d'erreurs et ajout d'une actualité. Vous gardez un site à jour sans avoir à vous en occuper.",
  },
  {
    q: "Qu'est-ce qu'un QR Code professionnel et à quoi ça sert ?",
    a: "Un QR Code professionnel est un code que vos clients scannent avec leur téléphone pour accéder directement à une page de votre site. Idéal pour vos cartes de visite, comptoir, flyers ou véhicules — il génère plus de visites, plus d'avis Google et plus de demandes de devis.",
  },
  {
    q: "Êtes-vous une agence locale dans le Tarn ?",
    a: "Oui. WebUP est basée à Marssac-sur-Tarn (81) et accompagne en priorité les entreprises d'Albi, Gaillac, Castres, Carmaux, Graulhet et plus largement de l'Occitanie. Nous privilégions les échanges directs, en visio ou sur place.",
  },
  {
    q: "Pouvez-vous refaire mon site existant ?",
    a: "Bien sûr. Nous réalisons des refontes complètes : nouvelle identité visuelle, structure, contenus et SEO. Nous conservons votre historique de référencement et migrons proprement vos URL pour ne pas perdre votre trafic.",
  },
  {
    q: "Le nom de domaine et l'hébergement sont-ils inclus ?",
    a: "Oui. Notre Pack Site Web Professionnel inclut le nom de domaine, l'hébergement, le certificat HTTPS et la mise en ligne. Vous repartez avec un site immédiatement opérationnel.",
  },
  {
    q: "Pouvez-vous ajouter un chatbot IA sur mon site ?",
    a: "Oui. Nous concevons et intégrons des chatbots intelligents capables de répondre 24h/24 aux questions de vos visiteurs, qualifier les prospects et même prendre des rendez-vous. Tarification sur devis selon le périmètre.",
  },
  {
    q: "Qu'est-ce qu'un agent vocal IA et à quoi ça sert ?",
    a: "Un agent vocal IA est un standard téléphonique intelligent qui décroche, comprend la demande du client, qualifie l'appel et peut même prendre rendez-vous dans votre agenda — 24h/24 et sans aucune attente. Idéal pour les artisans souvent en intervention.",
  },
  {
    q: "Comment se passe le paiement ?",
    a: "Nous demandons 30 % d'acompte au démarrage et 70 % à la livraison du projet, par virement bancaire. Aucun prélèvement automatique, aucune mensualité cachée. La maintenance, elle, est facturée mensuellement.",
  },
  {
    q: "Vais-je pouvoir modifier le contenu moi-même ?",
    a: "Selon votre besoin, nous livrons soit un site éditable via un back-office léger, soit un site optimisé en pur code (plus rapide) avec un contrat de maintenance pour les modifications. Nous adaptons la solution à votre niveau d'autonomie.",
  },
  {
    q: "Quels secteurs accompagnez-vous ?",
    a: "Tous les secteurs des entreprises locales : artisans (bâtiment, automobile, alimentation), commerces, professions libérales, PME, startups, indépendants et associations. Nous adaptons le discours et les fonctionnalités à votre marché.",
  },
  {
    q: "Comment se passe la première rencontre ?",
    a: "C'est un appel de découverte gratuit, sans engagement, en visio ou en face à face selon votre préférence. Nous échangeons sur votre activité, vos objectifs, votre concurrence locale, et identifions ensemble si un site WebUP est pertinent. Vous repartez avec une recommandation claire.",
  },
  {
    q: "Quelles garanties offrez-vous ?",
    a: "Engagement de résultat sur la livraison (délais, performance, SEO de base), maquette validée avant développement, devis ferme avant signature et hébergement sécurisé. Vous restez propriétaire du nom de domaine et de vos contenus.",
  },
  {
    q: "Puis-je avoir une boutique en ligne avec WebUP ?",
    a: "Oui. Nous pouvons concevoir une boutique en ligne complète (e-commerce) avec gestion de catalogue, paiement sécurisé et suivi de commandes. Ces projets sont chiffrés sur devis.",
  },
  {
    q: "Que se passe-t-il si je ne suis pas satisfait du résultat ?",
    a: "C'est précisément pour éviter cette situation que vous validez une maquette sous 48h avant tout développement. Nous travaillons en allers-retours rapides et personne ne paie le solde tant que le rendu n'est pas validé. La satisfaction client est notre seule mesure de succès.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-paper-soft border-t border-ink/5">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <p className="font-mono-label text-ink/60"><span className="rule" />FAQ</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl text-ink tracking-tight leading-[1.05]">
            Les questions fréquentes <em className="italic font-light">sur la création de sites web dans le Tarn</em>.
          </h2>
          <p className="mt-6 text-ink/65 leading-relaxed">
            Vous ne trouvez pas votre réponse ?
            <a href="#contact" className="text-ink link-under ml-1">Posez-nous votre question</a>.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-ink/10">
            {faqs.map((item, i) => (
              <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display text-xl md:text-2xl text-ink hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/70 leading-relaxed text-[15px] pb-6 pr-10">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  </section>
);
